export const districtList = {
    "central": { short: "ЦФО", full: "Центральный ФО" },
    "northwestern": { short: "СЗФО", full: "Северо-Западный ФО" },
    "southern": { short: "ЮФО", full: "Южный ФО" },
    "north_caucasian": { short: "СКФО", full: "Северо-Кавказский ФО" },
    "volga": { short: "ПФО", full: "Приволжский ФО" },
    "ural": { short: "УФО", full: "Уральский ФО" },
    "siberian": { short: "СФО", full: "Сибирский ФО" },
    "far_eastern": { short: "ДФО", full: "Дальневосточный ФО" }
};